
import { getFirestore } from 'redux-firestore';
import { observable } from "mobx"

export const account = observable({
    events: [],
    name: "",
    username: "",
    uid: "",
    email: ""
})

export const onSignIn = async uid => {
    console.log("signin")
    console.log(uid)

    const db = getFirestore();
    const user = await db
        .collection('users')
        .doc(uid)
        .get()

    const {email, name, password, username} = user.data()
    account.name = name
    account.username = username
    account.email = email
}

export const onSignOut = () => {
    console.log("signout")
}